import { WahooWorkoutTypeFamily } from "@WahooFitness/cloud-client-types";
import {
  BlueSwitch,
  MenuList,
  MenuListItemType,
  MenuListItemVariant,
} from "@WahooFitness/redesignr";
import { t } from "@lingui/macro";
import { useMemo, useState } from "react";
import useEditWorkoutProfile from "./useEditWorkoutProfile";
import { WSMWorkoutProfile } from "@WahooFitness/wsm-native/dist/esm/types/workout_profile";

const SensorsSection = ({ profile }: { profile?: WSMWorkoutProfile }) => {
  const { handleFieldsChange } = useEditWorkoutProfile(profile);

  const [zeroInAvgCadenceDisplay, setZeroInAvgCadenceDisplay] = useState<boolean>(
    !!profile?.include_zero_in_avg_cadence
  );

  const sectionItems = useMemo(
    () =>
      [
        {
          id: "zeroInAvgCadence",
          content: t`Include zero in average cadence`,
          variant: MenuListItemVariant.Action,
          actionComponent: <BlueSwitch checked={zeroInAvgCadenceDisplay} />,
          action: () => {
            handleFieldsChange({ include_zero_in_avg_cadence: !zeroInAvgCadenceDisplay });
            setZeroInAvgCadenceDisplay(!zeroInAvgCadenceDisplay);
          },
        },
      ] as MenuListItemType[],
    [handleFieldsChange, zeroInAvgCadenceDisplay]
  );

  const isCyclingProfile = useMemo(
    () => profile?.workout_type_family_id === WahooWorkoutTypeFamily.Cycling,
    [profile?.workout_type_family_id]
  );

  if (!isCyclingProfile) {
    return undefined;
  }

  return <MenuList title={t`Sensors`} variant="elevation" listItems={sectionItems} />;
};

export default SensorsSection;
